import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
class HexoProductInfo extends Component {
  #controller;
  #generation = 0;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    if (matchMedia('(max-width: 749px)').matches) {
      const specifications = this.querySelector('[data-hx-specifications] details, .hx-product-accordions > details[open]');
      if (specifications) specifications.open = false;
    }
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#update, { signal: this.#controller.signal });
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#controller?.abort(); this.#generation++; }
  #update = async event => {
    if (event.target.closest('product-card')) return;
    const generation=++this.#generation;
    try {
      const { detail }=await event.promise;
      if (!this.isConnected || generation!==this.#generation || String(detail?.productId)!==this.dataset.productId) return;
      for (const selector of ['[data-hx-availability]', '[data-hx-specifications]']) {
        const next = detail.html?.querySelector(`hexo-product-info ${selector}`);
        const current = this.querySelector(selector);
        if (!current) continue;
        const open = current.querySelector('details')?.open;
        current.hidden = !detail.resource || !next;
        if (next) current.replaceChildren(...[...next.childNodes].map(node => node.cloneNode(true)));
        const disclosure = current.querySelector('details');
        if (disclosure && open !== undefined) disclosure.open = open;
      }
    } catch { /* A subsequent selection can abort the previous request. */ }
  };
}
if (!customElements.get('hexo-product-info')) customElements.define('hexo-product-info',HexoProductInfo);


